import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
import { AttendanceTableColumns, MonthlyPlaceTableColumns } from './-table/type';
export const AttendanceDailyPlaceTableFilterSchema = z.object({
  orderDirection: z.nativeEnum(OrderDirection).default(OrderDirection.ASC).optional(),
  sortColumn: z.enum([AttendanceTableColumns.PERSON, AttendanceTableColumns.ERRORS]).optional(),
  freeText: z.string().optional(),
  placeId: z.string().optional(),
  date: z.string().optional()
});
export type AttendanceDailyPlaceTableFilter = z.infer<typeof AttendanceDailyPlaceTableFilterSchema>;
export const AttendanceMonthlyPersonTableFilterSchema = z.object({
  orderDirection: z.nativeEnum(OrderDirection).default(OrderDirection.ASC).optional(),
  sortColumn: z.enum([AttendanceTableColumns.DATE, AttendanceTableColumns.ERRORS]).optional(),
  year: z.number().optional(),
  month: z.number().optional(),
  // NOTE: 通常の画面遷移ではpersonIDは設定されているはずではあるが、URL直接アクセスなどでpersonIdがない場合でもAPIは許容しているため、スキーマ上optionalとしている
  personId: z.string().optional()
});
export type AttendanceMonthlyPersonTableFilter = z.infer<typeof AttendanceMonthlyPersonTableFilterSchema>;
export const AttendanceMonthlyPlaceTableFilterSchema = z.object({
  orderDirection: z.nativeEnum(OrderDirection).default(OrderDirection.ASC).optional(),
  sortColumn: z.enum([MonthlyPlaceTableColumns.PERSON, MonthlyPlaceTableColumns.WORKING_DAYS, MonthlyPlaceTableColumns.TOTAL_WORKING_TIME, MonthlyPlaceTableColumns.ERROR_COUNT]).optional(),
  year: z.number().optional(),
  month: z.number().optional(),
  placeId: z.string().optional(),
  freeText: z.string().optional()
});